import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import axios from 'axios'

import { AUTH_USER, UNAUTH_USER } from './actions/types'
import Header from './components/header'
import Welcome from './components/welcome'
import injectTapEventPlugin from 'react-tap-event-plugin'
import Signin from './components/auth/signin'
import Signout from './components/auth/signout'
import { PrivateRoute } from './components/auth/require_auth'
import reducers from './reducers'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import CONS from './constants';

import Fees from './components/fees/fees'
import Skgroups from './components/selfknowledgegroups/selfknowledgegroups'
import Tgroups from './components/traininggroups/traininggroups'
import Feestatistics from './components/feestatistics/feestatistics'
import Groupstatistics from './components/groupstatistics/groupstatistics'
import Tbstatistics from './components/tbstatistics/tbstatistics'
import Persons from './components/persons/persons'
import Settings from './components/settings/settings'
import Tb from './components/tb/tb'

// Needed for onTouchTap with material-ui
// http://stackoverflow.com/a/34015469/988941

injectTapEventPlugin()

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore)
const store = createStoreWithMiddleware(reducers, composeWithDevTools())
const ROOT_URL = CONS.host;

if (typeof localStorage.getItem('refreshToken') !== 'undefined') {
  axios.post(ROOT_URL+'/auth.refresh', {
    token: localStorage.getItem('refreshToken')
  })
    .then(response => {
      // -Save tokens
      localStorage.setItem('token', response.data.accessToken)
      localStorage.setItem('refreshToken', response.data.refreshToken)
      localStorage.setItem('validUntil', response.data.validUntil)
      store.dispatch({type: AUTH_USER})
    })
    .catch(() => {
      store.dispatch({type: UNAUTH_USER})
    })
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <MuiThemeProvider>
        <div>
          <Header/>
          <Switch>
            <Route path="/signin" component={Signin}/>
            <PrivateRoute path="/" exact={true} component={Welcome}/>
            <PrivateRoute path="/signout" component={Signout}/>
            <PrivateRoute path="/persons" component={Persons}/>
            <PrivateRoute path="/fees" component={Fees}/>
            <PrivateRoute path="/training-groups" component={Tgroups}/>
            <PrivateRoute path="/self-knowledge-groups" component={Skgroups}/>
            <PrivateRoute path="/feestatistics" component={Feestatistics}/>
            <PrivateRoute path="/tbstatistics" component={Tbstatistics}/>
            <PrivateRoute path="/groupstatistics" component={Groupstatistics}/>
            <PrivateRoute path="/settings" component={Settings}/>
            <PrivateRoute path="/tb" component={Tb}/>
          </Switch>
        </div>
      </MuiThemeProvider>
    </BrowserRouter>
  </Provider>
  , document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js